import { enqueueSnackbar, OptionsObject } from 'notistack'

export const showToast = (text: string, options: OptionsObject = {}) => {
  enqueueSnackbar(text, {
    autoHideDuration: 3000,
    ...options,
  })
}
